// Imports
import { PortalContext } from "src/modules/01 Global/jsx/contexts.jsx";
import { Tooltip } from "src/modules/tooltip/jsx/component.jsx";

// Stateful components

export class FeeStatus extends React.Component{

    //
    // Lifecycle 
    //

    constructor(props) {
        super(props);

        this.state = {
            "programs": null,
        };

        // Binds
    }

    componentDidMount(){
        var this_component = this;

        // get relevant storage objects
        var my_fees_storage_v2 = squiz.fn.getStorage('getmyfeesv2', 'session', 'json');
        var has_fees = false;
        
        if(my_fees_storage_v2 && my_fees_storage_v2['data']){
            my_fees_storage_v2 = my_fees_storage_v2['data'];
            has_fees = true;
        } else {
            has_fees = false;
        }
       
        if(has_fees){

            // if gu_sp_fee_stts is in v2 data
            var fee_status = my_fees_storage_v2['feeStatus'];

            if (fee_status && fee_status.length > 0) {
                this_component.setState({
                    "programs": fee_status
                });
            }
        }

    }

    //
    // Functions
    //

    checkForAttributeOverride(attribute_key) {
        var this_component = this;
        var portal_context = this_component['context'];
        var user_personalisation = portal_context['user_personalisation'];
        var configuration = portal_context['configuration'];
        var fee_config = configuration['fees'];

        if(typeof(user_personalisation) !== 'undefined') {
            var user_attributes = user_personalisation['attributes'];

            if(typeof(user_attributes) !== 'undefined') {
                var attribute_value = user_attributes[attribute_key];

                if(typeof(attribute_value) !== 'undefined') {
                    var custom_status = fee_config['custom_status'];

                    switch(attribute_key) {
                        case 'PEQ':
                            return this_component.getPEQButton(attribute_value, custom_status[attribute_key]);
                    }
                }
            }
        }

        return null;
    }

    getPEQButton(attribute_value, available_options) {
        var link_data = {
            'link_url': '',
            'link_text': ''
        };

        // If PEQ is T (true), update the link
        if(attribute_value === true) {
            var peq_link_data = available_options['T'];
            
            link_data['link_id'] = peq_link_data['peoplesoft_id'];
            link_data['link_text'] = peq_link_data['link_description'];

            return link_data;
        }
        
        return null;
    }

    getMatchingTooltip(tooltip_key, tooltip_status) {
        var this_component = this;
        var portal_context = this_component['context'];
        var helpers = portal_context['helpers'];

        var current_page = portal_context['current_page'];
        var page_data = helpers.getPageBySlug(current_page);


        if (typeof page_data['content'] != 'undefined' && typeof page_data['content']['tooltips'] != 'undefined') {
            var tooltips = page_data['content']['tooltips'];
            if (tooltips) {
                var tooltip_arr = tooltips[tooltip_key];

                if (tooltip_arr) {
                    var matching_tooltips = tooltip_arr.filter(function(tooltip, key) {
                        return tooltip['name'] === tooltip_status.toLowerCase();
                    });
                    if (matching_tooltips.length > 0) {
                        var matching_tooltip = matching_tooltips[0];
                        return matching_tooltip;
                    }
                }
            }
        }

        return null;
    }

    //
    // Render
    //

    renderTooltip(tooltip, tooltip_class, tooltip_text) {
        var tooltip_content = {
            'title': tooltip['title'],
            'info': tooltip['message'],
            'link': tooltip['link'],
            'link_text': tooltip['link_text'],
            'button': {
                'class': tooltip_class,
                'text': tooltip_text
            }
        };

        return <Tooltip content={tooltip_content} />;
    }

    renderHelpStatus(fee_status) {
        var this_component = this;
        var portal_context = this_component['context'];
        var helpers = portal_context['helpers'];
        var configuration = portal_context['configuration'];
        var fee_config = configuration['fees'];

        // Get help status description and link
        var helpStatus = fee_status['helpStatus'];
        var helpLink = null;
        var helpLinkText = null;
        var helpStatusData = fee_config['help_status'][helpStatus.toLowerCase()];

        if(helpStatusData){
            if(helpStatusData['peoplesoft_id']){
                helpLink = helpers.generateStudentCentreUrl(helpStatusData['peoplesoft_id']);
            }
            if(helpStatusData['link_description']){
                helpLinkText = helpStatusData['link_description'];
            } 
        }

        // Check for custom attributes
        var peq_data = this_component.checkForAttributeOverride('PEQ');

        if(peq_data !== null) {
            helpLink = helpers.generateStudentCentreUrl(peq_data['link_id']);
            helpLinkText = peq_data['link_text'];
        }
        
        var tooltip = <span className="payment-options__title">{fee_status['statusDescription']}</span>;
        var tooltip_data = this.getMatchingTooltip('help_status', helpStatus);
        if (tooltip_data !== null) {
            tooltip = this.renderTooltip(tooltip_data, 'fee-status__payment-type__title', fee_status['statusDescription']);
        }

        return (
            <div className="fee-status__payment-type">
                                
                {tooltip}

                {helpLink && 
                    <a href={helpLink} className="fee-status__payment-type__change">
                        {helpLinkText}
                    </a>
                }
                
            </div>
        );
    }

    renderSsafStatus(fee_status) {
        var this_component = this;
        var portal_context = this_component['context'];
        var helpers = portal_context['helpers'];
        var configuration = portal_context['configuration'];
        var fee_config = configuration['fees'];

        // Get ssaf status description and link
        var ssafStatus = fee_status['saHelpStatus'];
        var ssafLink = null;
        var ssafLinkText = null;
        var ssafStatusData = fee_config['ssaf_status'][ssafStatus.toLowerCase()];

        if(ssafStatusData){
            if(ssafStatusData['peoplesoft_id']){
                ssafLink = helpers.generateStudentCentreUrl(ssafStatusData['peoplesoft_id']);
            }
            if(ssafStatusData['link_description']){
                ssafLinkText = ssafStatusData['link_description'];
            }
        }

        if (ssafStatus) {

            var tooltip = <span className="fee-status__ssaf-status__title">SSAF Status</span>;
            var tooltip_data = this.getMatchingTooltip('ssaf_status', ssafStatus);
            if (tooltip_data !== null) {
                tooltip = this.renderTooltip(tooltip_data, 'fee-status__ssaf-status__title', 'SSAF Status');
            }

            return (
                <>
                    <div className="fee-status__ssaf-status">
                        {tooltip}
                    </div>
                    <div className="fee-status__application-status">
                        
                        {ssafLink ? 
                            <a href={ssafLink} className="fee-status__application-status__indicator">
                                {ssafLinkText}
                            </a>
                        : 
                            <div className="fee-status__application-status__indicator">
                                {ssafLinkText}
                            </div>
                        }
                        
                    </div>
                </>
            );
        }

        return null;
    }

    
    // Render fee status for selected program
    render() {
        var this_component = this;
        
        var programs = this_component['state']['programs'];
        var current_program_index = this_component['props']['index'];

        if (current_program_index !== null && programs) {
            var fee_status_data = programs[current_program_index];

            if(fee_status_data) {

                var helpStatus = this.renderHelpStatus(fee_status_data);
                var ssafStatus = this.renderSsafStatus(fee_status_data);

                if (helpStatus || ssafStatus) {
                    
                    var wrapper_class = 'fee-status__wrapper';
                    if (ssafStatus) {
                        wrapper_class += ' fee-status--two-col'; 
                    }
    
                    // Fee status markup
                    return (
                        <div className={wrapper_class}>
                            <h2 className="fee-status__title">
                                Fee Status
                            </h2>

                            {helpStatus}
                            {ssafStatus}
                        </div>
                    );
                }
            }
        }

        return null;
    }

    
};

FeeStatus.contextType = PortalContext;
